/**
 * Category grid — autoplay mudo em loop; botão para ativar som.
 */
(function () {
  function isVideoUnmuted(video) {
    var media = video.closest('.category-grid__media');
    var btn = media && media.querySelector('[data-vf-video-mute]');
    return !!(btn && btn.classList.contains('is-unmuted'));
  }

  function applyMuteState(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    var unmuted = isVideoUnmuted(video);
    video.muted = !unmuted;

    if (unmuted) {
      video.removeAttribute('muted');
    } else {
      video.setAttribute('muted', '');
    }
  }

  function playVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    video.autoplay = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');

    applyMuteState(video);

    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    video.pause();
  }

  function initMuteButtons(section) {
    section.querySelectorAll('[data-vf-video-mute]').forEach(function (btn) {
      if (btn.dataset.vfMuteBound === 'true') return;
      btn.dataset.vfMuteBound = 'true';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var media = btn.closest('.category-grid__media');
        var video = media && media.querySelector('.category-grid__video');
        if (!(video instanceof HTMLVideoElement)) return;

        var unmuted = !btn.classList.contains('is-unmuted');
        btn.classList.toggle('is-unmuted', unmuted);
        btn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
        btn.setAttribute(
          'aria-label',
          unmuted ? btn.dataset.labelMute || 'Silenciar vídeo' : btn.dataset.labelUnmute || 'Ativar som'
        );

        applyMuteState(video);

        if (unmuted) {
          video.play().catch(function () {});
        }
      });
    });
  }

  function bindVideoEvents(video) {
    if (video.dataset.vfAutoplayBound === 'true') return;
    video.dataset.vfAutoplayBound = 'true';

    ['loadeddata', 'canplay'].forEach(function (eventName) {
      video.addEventListener(
        eventName,
        function () {
          playVideo(video);
        },
        { once: true }
      );
    });
  }

  function initAutoplayVideos(section) {
    var videos = section.querySelectorAll('.category-grid__video');
    if (!videos.length) return;

    initMuteButtons(section);

    videos.forEach(function (video) {
      bindVideoEvents(video);
      playVideo(video);
    });

    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -5% 0px' }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function boot() {
    document.querySelectorAll('.category-grid[data-has-videos], .category-grid[data-has-featured-video]').forEach(initAutoplayVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
